module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"link":"查看原文"}}')
  delete Component.options._Ctor
}
